import { Row } from "antd";
import React from "react";

import { ClearLink } from "./styled";
import { ClearFiltersProps } from "./types";

export const ClearFilters: React.FC<ClearFiltersProps> = ({ queryDispatch }) => {
  const handleClearFilters = () => {
    queryDispatch({
      type: "reset",
    });
  };

  return (
    <Row>
      <ClearLink onClick={handleClearFilters}>Clear all filters</ClearLink>
    </Row>
  );
};
